import { useIdentity } from "base/identity-resolver";
import { fetchJourneyTitlesAndCounts } from "../utils/api-requests/journey-index";
import { useState, useEffect } from "react";

//TODO: DELETE THIS FILE
// This hook is used to populate the journey titles at the top of the journey detail page.
// the query only contains ID, Name, and Task Counts for each Journey. 
const useJourneyTitles = (selectedDueDate, selectedJourneyGroup = {}) => {
  const { user } = useIdentity();

  const [journeyTitles, setJourneyTitles] = useState([]);

  useEffect(() => {
    const getAndSetJourneys = async () => {
      const journeysList = await fetchJourneyTitlesAndCounts(
        selectedJourneyGroup.id,
        user.id,
        ["IN_PROGRESS"],
        selectedDueDate
      );
      setJourneyTitles(journeysList);
    };

    getAndSetJourneys();
  }, [selectedJourneyGroup.id, selectedDueDate, user.id]);

  const updateJourneyTitleNumber = (step, task, completed_at) => {
    const journeysCopy = [...journeyTitles];
    const journeyIndexToUpdate = journeysCopy.findIndex((j) => j.id === step.journey_id);
    const journeyToUpdate = journeysCopy.find((j) => j.id === step.journey_id);
    journeyToUpdate.tasks_due_counts.total = completed_at
      ? journeyToUpdate.tasks_due_counts.total - 1
      : journeyToUpdate.tasks_due_counts.total + 1;
    journeysCopy[journeyIndexToUpdate] = journeyToUpdate;
    setJourneyTitles(journeysCopy);
  };

  return {
    journeyTitles,
    updateJourneyTitleNumber,
  };
};

export default useJourneyTitles;
